/**
 * Convert a flag emoji to its ISO 3166-1 alpha-2 code (lowercase).
 *
 * A flag emoji is a pair of "regional indicator symbols" (U+1F1E6–U+1F1FF),
 * each mapping to a letter A–Z. e.g. 🇸🇦 → "sa", 🇪🇬 → "eg".
 *
 * Returns null when the input isn't exactly two regional indicators so callers
 * can fall back gracefully.
 */
export const emojiFlagToIsoCode = (emoji?: string): string | null => {
  if (!emoji) return null;

  const REGIONAL_INDICATOR_START = 0x1f1e6;
  const REGIONAL_INDICATOR_END = 0x1f1ff;

  const letters = Array.from(emoji)
    .map((char) => char.codePointAt(0) ?? 0)
    .filter(
      (cp) => cp >= REGIONAL_INDICATOR_START && cp <= REGIONAL_INDICATOR_END
    )
    .map((cp) =>
      String.fromCharCode(cp - REGIONAL_INDICATOR_START + "a".charCodeAt(0))
    );

  return letters.length === 2 ? letters.join("") : null;
};
